import { Field } from 'formik';
import styled from 'styled-components';
import { css } from 'styled-components';
import { INLINE_CONTROL_MIN_HEIGHT } from '../QuestionRow/QuestionRow.styled';

interface StyledProps {
  hasImages: boolean;
}

export const BooleanQuestionWrapper = styled.div`
  // Hugs the toggle at every width. Stretching it to 100% on narrow screens
  // makes the cell claim the whole row, which pushes the toggle away from the
  // question name and back onto a line of its own.
  width: auto;

  // The toggle drops to MUI's small size on phones, so the wrapper rather than
  // the toggle carries the shared line height and centres whatever size it is.
  display: flex;
  align-items: center;
  min-height: ${INLINE_CONTROL_MIN_HEIGHT}rem;

  ${(props: StyledProps) =>
    props.hasImages &&
    css`
      align-self: flex-end;
    `};
`;

export const StyledField = styled(Field)`
  align-self: flex-end;
`;

export const ColorInputWrapper = styled.div`
  align-self: flex-start;
  width: 100%;
`;
